import { all, call, takeLatest, put } from "redux-saga/effects";
import axios from "axios";
import { replace, push } from "connected-react-router/immutable";
import { setUser } from "../store/auth/actions";
import {
  GET_ACCESS_TOKEN,
  INITIAL_AUTH,
  LOGOUT
} from "../store/auth/constants";
import { setLoader, removeLoader, setError, errorParser } from "../store/preloader/actions";
import { GLOBAL_LOADER } from "../store/preloader/constants";
import Api from "../api";
import {deleteAllCookies} from "../Services/cookie";

export function* initialAuthSaga(action) {
  yield put(setLoader(GLOBAL_LOADER, INITIAL_AUTH, "АВТОРИЗАЦИЯ"));
  try {
    const { accessToken } = action.payload;
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    const response = yield call(Api.auth.getUser);
    yield put(setUser(response.data));
    localStorage.clear();

    if (window.location.href.includes("login") || window.location.href.includes("logout")) {
       yield put(push("/registry"));
    }
  } catch (error) {
    deleteAllCookies();
    if (error.response && error.response.status === 403) {
      yield put(setError(`АВТОРИЗАЦИЯ код 403 - ${ errorParser(error) || error.message }`));
    } else {
      yield put(setError(`АВТОРИЗАЦИЯ - ${ errorParser(error) || error.message }`));
    }
    const trySSO = localStorage.getItem("trySSO");
    if(Number(trySSO || '0') === 1) {
      localStorage.setItem("trySSO", '0');
      yield put(push("/login"));
    } else {
      localStorage.setItem("trySSO", '1');
      yield put(push("/try_redirect_sso"));
    }
  }

  yield put(removeLoader(GLOBAL_LOADER, INITIAL_AUTH));
}
export function* initialAuthFlow() {
  yield takeLatest(INITIAL_AUTH, initialAuthSaga);
}

export function* getAccessTokenSaga(action) {
  yield put(setLoader(GLOBAL_LOADER, GET_ACCESS_TOKEN, "ПОЛУЧЕНИЕ ТОКЕНА"));

  try {
    const { authorizeCode } = action.payload;

    const response = yield call(Api.auth.getToken, authorizeCode);

    const accessToken = response.data.access_token;

    localStorage.setItem("accessToken", accessToken);

    yield put(replace("/"));
  } catch (error) {
    yield put(setError(`ПОЛУЧЕНИЕ ТОКЕНА - ${ errorParser(error) || error.message }`));
  }

  yield put(removeLoader(GLOBAL_LOADER, GET_ACCESS_TOKEN));
}
export function* getAccessTokenFlow() {
  yield takeLatest(GET_ACCESS_TOKEN, getAccessTokenSaga);
}

export function* logoutSaga() {
  yield put(setLoader(GLOBAL_LOADER, LOGOUT, "ВЫХОД"));
  try {
    deleteAllCookies();
    const userDef =  {
      admin: false,
      email: "",
      fullName: "",
      id: ""
    };
    yield put(setUser(userDef));
    localStorage.clear();
    axios.defaults.headers.common.Authorization = "";
    yield put(push("/logout"));
  } catch (error) {
    yield put(setError(`ВЫХОД - ${ errorParser(error) || error.message }`));
  }

  yield put(removeLoader(GLOBAL_LOADER, LOGOUT));
}
export function* logoutFlow() {
  yield takeLatest(LOGOUT, logoutSaga);
}

export default function* auth() {
  yield all([initialAuthFlow(), getAccessTokenFlow(), logoutFlow()]);
}
